export default class Steps {
  constructor() {
    document.querySelectorAll('.js-steps').forEach($el => new StepsElement($el));
  }
}

class StepsElement {
  MIN_DESKTOP_WIDTH = 1440;

  constructor($el) {
    this.$el = $el;
    this.$bar = this.$el.querySelector('.js-steps-bar');
    this.$progressBar = this.$el.querySelector('.js-steps-progress-bar');
    this.$steps = document.querySelectorAll('.js-steps-bar-step');
    this.$container = this.$el.querySelector('.js-steps-progress-container');

    if (this.$container) {
      this.buildLeftPoints();
      window.addEventListener('scroll', this.scroll.bind(this));
      window.addEventListener('resize', this.resize.bind(this));
    }
  }

  buildLeftPoints() {
    this.leftPoints = [];

    const { width } = this.$container.getBoundingClientRect();
    const { offsetWidth } = document.body;

    this.$steps.forEach($step => {
      const { left } = $step.getBoundingClientRect();

      let percentage = Math.round((left / offsetWidth) * 100);

      if (window.innerWidth < this.MIN_DESKTOP_WIDTH) {
        percentage = Math.round((left / (width + offsetWidth)) * 100);
      }

      this.leftPoints.push(percentage);
    });
  }

  scroll() {
    const viewportTop = document.body.scrollTop + document.documentElement.scrollTop;
    const componentRect = this.$el.getBoundingClientRect();
    const componentPageOffsetY = componentRect.top + viewportTop;
    const viewportHeight = window.innerHeight;
    const wpAdminBar = document.getElementById('wpadminbar');
    const siteHeader = document.querySelector('.js-header');
    const siteHeaderHight = wpAdminBar ? wpAdminBar.offsetHeight + siteHeader.offsetHeight : siteHeader.offsetHeight;
    const componentViewportScroll = Math.min(1, Math.max(0, (viewportTop - componentPageOffsetY + siteHeaderHight + viewportHeight / 3) / componentRect.height));

    this.leftPoints.forEach((point, index) => {
      this.$steps[index].classList.toggle('has-passed', componentViewportScroll * 100 >= point);
    });

    const percentage = componentViewportScroll * 100;

    this.$progressBar.style.width = `${percentage}%`;

    if (window.innerWidth < 1440) {
      this.$container.style.transform = `translateX(-${percentage}%)`;
    }
  }

  resize() {
    this.$container.style.transform = `translateX(0)`;
    this.buildLeftPoints();
  }
}
